var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 15H1M24.8333 1V8M10.1667 1V8M14.75 22L17.5 20.25V29M15.2083 29H19.7917M9.8 36H25.2C28.2803 36 29.8204 36 30.9969 35.4278C32.0318 34.9244 32.8732 34.1213 33.4005 33.1334C34 32.0104 34 30.5403 34 27.6V12.9C34 9.95972 34 8.48959 33.4005 7.36655C32.8732 6.3787 32.0318 5.57555 30.9969 5.07222C29.8204 4.5 28.2803 4.5 25.2 4.5H9.8C6.71971 4.5 5.17957 4.5 4.00305 5.07222C2.96816 5.57555 2.12677 6.3787 1.59946 7.36655C1 8.48959 1 9.95972 1 12.9V27.6C1 30.5403 1 32.0104 1.59946 33.1334C2.12677 34.1213 2.96816 34.9244 4.00305 35.4278C5.17957 36 6.71971 36 9.8 36Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar_2.a4397d2871538bd0207fe605acd8e4af.svg";
export { ForwardRef as ReactComponent };